<app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo"
                  [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
</ng-template>
<ng-template #enviarTemplate>
  <br>
  <section class="section">
    <form [formGroup]="formulario" class="form-group" novalidate>
      <div class="row">
        <div class="col-md-3">
          <app-lfsa-combo-box (change)="getArticuloByCliente()" [claseLabel]="'letrasDanger'" [comboBox]="cmbCliente"
                              [control]="formulario.get('cliente')" [idOpcion]="'cliId'" [id]="'cliente'"
                              [label]="'Cliente*'"
                              [opcion]="'cliNombre'" formControlName="cliente"></app-lfsa-combo-box>
        </div>
        <div class="col-md-3">
          <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbArticulo" [control]="formulario.get('articulo')"
                              [idOpcion]="'artId'" [id]="'articulo'" [label]="'Artículo*'"
                              [opcion]="'artDescripcion'"
                              formControlName="articulo"></app-lfsa-combo-box>
        </div>
        <div class="col-md-3">
          <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('fechaFinal')" [id]="'fechaFinal'" [label]="'Fecha*'"
                          [placeholder]="'Fecha'" [type]="'date'" formControlName="fechaFinal">
          </app-lfsa-input>
        </div>
        <div class="col-md-2">
          <label for=""></label><br>
          <button (click)="buscar()" [disabled]="formulario.invalid" [tooltip]="'BUSCAR/GRAFICAR'"
                  class="btn btn-success btn-block"><i class="fa fa-search"></i></button>
        </div>
        <div class="col-md-1">
          <label for=""></label><br>
          <button (click)="generarPdf()" [disabled]="formulario.invalid" [tooltip]="'EXPORTAR PDF'" class="btn btn-success btn-block"><i
            class="fa fa-file-pdf"></i></button>
        </div>
        <!--<div class="col-md-1">
          <label for=""></label><br>
          <button [disabled]="formulario.invalid" [tooltip]="'ENVIAR CORREO'" class="btn btn-success btn-block"><i
            class="fa fa-envelope"></i></button>
        </div>-->
      </div>
    </form>
    <hr>
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button aria-controls="home" aria-selected="true" class="nav-link active" data-bs-target="#home" data-bs-toggle="tab"
                id="home-tab" role="tab" type="button">Gráfico
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button (click)="notInvetarioDetallado()" aria-controls="profile" aria-selected="false" class="nav-link"
                data-bs-target="#profile" data-bs-toggle="tab" id="profile-tab" role="tab"
                type="button">Inventario
        </button>
      </li>
      <li class="nav-item" role="presentation">
        <button (click)="getInvetarioDetallado()" aria-controls="contact" aria-selected="false" class="nav-link"
                data-bs-target="#contact" data-bs-toggle="tab" id="contact-tab" role="tab" type="button">
          Inventario
          Detallado
        </button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div aria-labelledby="home-tab" class="tab-pane fade show active" id="home" role="tabpanel">
        <div class="row">
          <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading"></app-lfsa-alerts>
          <div class="col-md-12">
            <!--<app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>-->
            <img [src]="imagenB64" class="center" *ngIf="!listaVacia"/>
          </div>
          <!--<app-lfsa-gh-dual-axes *ngIf="!listaVacia" [dataY1]="listVmiStockfisico"
                                 [dataY2]="listVmiPorcpenetracionreal" [listVmiAmortamarillo]="listVmiAmortamarillo" [listVmiAmortrojo]="listVmiAmortrojo"
                                 [listVmiAmortverde]="listVmiAmortverde"
                                 [title]="'% Penetración: ' + lista[0]?.cliente?.cliNombre" [titlesX]="listVmiFechaReg"
                                 [unidadTextY1]="'Kilogramos'"
                                 [unidadTextY2]="'Penetración'" [unidadY1]="'Kg'"
                                 [unidadY2]="'%'"></app-lfsa-gh-dual-axes>-->
        </div>
      </div>
      <div aria-labelledby="profile-tab" class="tab-pane fade" id="profile" role="tabpanel">
        <!-- <br> -->
        <section class="section">
          <div class="row">
            <div class="col-md-12 ">
              <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading" [texto]="DAT_TITULOS.listaVacia">
              </app-lfsa-alerts>
              <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                               [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                               [pagination]="true" [rowData]="rowData" [rowSelection]="rowSelection"
                               [style]="modulo.agGrid.style" class="ag-theme-alpine"
                               [paginationPageSize]="$any(modulo.agGrid).paginacion">
              </ag-grid-angular>
            </div>
          </div>
        </section>
      </div>
      <div aria-labelledby="contact-tab" class="tab-pane fade" id="contact" role="tabpanel">
        <section class="section">
          <div class="row">
            <div class="col-md-12 ">
              <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading2" [texto]="DAT_TITULOS.listaVacia">
              </app-lfsa-alerts>
              <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                               [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                               [pagination]="true" [rowData]="rowData" [rowSelection]="rowSelection"
                               [style]="modulo.agGrid.style" class="ag-theme-alpine"
                               [paginationPageSize]="$any(modulo.agGrid).paginacion">
              </ag-grid-angular>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</ng-template>
